export const dbaKeys = {
  accountsAll: ['dba', 'accounts'] as const,
  accounts: (q: string) => ['dba', 'accounts', q] as const,
  accountAll: ['dba', 'account'] as const,
  account: (accountId: number) => ['dba', 'account', accountId] as const,
  discounts: ['dba', 'discounts'] as const,
  actionsAll: ['dba', 'actions'] as const,
  actions: (limit: number) => ['dba', 'actions', limit] as const,
  user: ['auth', 'user'] as const,
};
